export default __webpack_public_path__ + "static/media/photoCAdd.a22d8ed7.png";